

export class DeviceBrandUpdateInput implements IDeviceBrandUpdateInput {
    /** The auto-generated id of the device brand  master */
    deviceBrandId!: number;
    /** The device brand name with 255 character limit */
    deviceBrandName!: string;

    constructor(data?: IDeviceBrandUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceBrandId = _data["deviceBrandId"];
            this.deviceBrandName = _data["deviceBrandName"];
        }
    }

    static fromJS(data: any): DeviceBrandUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceBrandUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceBrandId"] = this.deviceBrandId;
        data["deviceBrandName"] = this.deviceBrandName;
        return data; 
    }
}

export interface IDeviceBrandUpdateInput {
    /** The auto-generated id of the device brand  master */
    deviceBrandId: number;
    /** The device brand name with 255 character limit */
    deviceBrandName: string;
}

